var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { mergeParams } from "../core/gameUtils/module/urlQueryAndHash";
import { loadScript } from "./loadScriptNoCache";
// 获取url query
export var parseQuery = function () {
    var search = location.search;
    var r = /([^=&?#]+)=([^&#]*)/g;
    var matches = search.match(r);
    if (!matches || !matches.length) {
        return {};
    }
    var query = {};
    matches.forEach(function (str) {
        var idx = str.indexOf('=');
        query[str.substr(0, idx)] = decodeURIComponent(str.substr(idx + 1));
    });
    return query;
};
// 判断是否是iOS
export var isIOS = function () {
    var ua = navigator.userAgent;
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
};
// 判断是否是Android
export var isAndroid = function () {
    return /Android/i.test(navigator.userAgent);
};
// 判断是否是微信
export var isWeixin = function () {
    return /micromessenger/i.test(navigator.userAgent);
};
// 判断是否是QQ app内
export var isQQ = function () {
    return / QQ/.test(navigator.userAgent);
};
// 判断是否是沙箱
export var isSandbox = function () {
    try {
        var origin_1 = location.origin;
        if (origin_1.indexOf('localhost') > -1 || origin_1.indexOf('sandbox') > -1 || origin_1.indexOf('bytedance.net') > -1) {
            return true;
        }
        return false;
    }
    catch (_) {
        return false;
    }
};
// 判断是否是mobile
export var isMobile = function () {
    var nv = navigator;
    if (/mobi|Mobile|Android|iP(hone|od|ad)|BlackBerry|Opera M(obi|ini)/i.test(nv.userAgent)) {
        return true;
    }
    try {
        // 尝试用废弃的属性来判断老式的机型
        if (/Android|iPhone|iPad|iPod/i.test(nv.platform)) {
            return true;
        }
    }
    catch (_) { }
    try {
        // 尝试用特定平台的属性来判断设备
        if (nv.userAgentData) {
            return nv.userAgentData.mobile;
        }
    }
    catch (_) { }
    try {
        // 尝试检测拥有移动端事件的设备
        if ('ontouchstart' in window) {
            return true;
        }
    }
    catch (_) { }
    return false;
};
export var isIpad = function () {
    var uaDetect = function () {
        try {
            var agent = navigator.userAgent.toLowerCase();
            // ios系统 < 13
            var lowerPattern = /iPad/i;
            // ios系统 >= 13
            var upperIPad = navigator.platform.toLowerCase() === 'macintel' && navigator.maxTouchPoints > 1;
            return lowerPattern.test(agent) || upperIPad;
        }
        catch (_) {
            return false;
        }
    };
    var deviceWidthDetect = function () {
        try {
            var ua = navigator.userAgent;
            var width = window.innerWidth || document.documentElement.clientWidth;
            var height = window.innerHeight || document.documentElement.clientHeight;
            if (/mac/i.test(ua) && /safari/i.test(ua)) {
                var pd, pdPro, pdAir;
                if (isLandscape()) {
                    pd = width === 1024 && (height >= 668 && height <= 768);
                    pdAir = width === 1180 && (height >= 720 && height <= 820);
                    pdPro = width === 1366 && (height >= 924 && height <= 1024);
                }
                else {
                    pd = width === 768 && (height >= 924 && height <= 1024);
                    pdAir = width === 820 && (height >= 1080 && height <= 1180);
                    pdPro = width === 1024 && (height >= 1266 && height <= 1366);
                }
                return pd || pdPro || pdAir;
            }
        }
        catch (_) {
            return false;
        }
        return false;
    };
    var isLandscape = function () {
        try {
            var orientation = window.orientation;
            if (orientation === 90 || orientation === -90) {
                return true;
            }
            return false;
        }
        catch (_) {
            return false;
        }
    };
    return uaDetect() || deviceWidthDetect();
};
// 校验邮箱
export var validateEmail = function (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
// 检查手机号格式
export var validateMobile = function (mobile) {
    return /^1[23456789]\d{9}$/.test(mobile);
};
// 变量类型
export var customTypeOf = function (value) {
    return Object.prototype.toString.call(value);
};
export var _toString = Object.prototype.toString;
// 获取类型，例如Object Array Number...
export var getType = function (target) {
    return customTypeOf(target).slice(8, -1);
};
export var isDouyin = function () {
    return /aweme/i.test(navigator.userAgent);
};
export var isInGame = function () {
    return /BDGameSDK/i.test(navigator.userAgent);
};
export var getAppType = function () {
    var UA = navigator.userAgent;
    switch (true) {
        case /(NewsArticle)[\s/_](\d.\d.\d)/i.test(UA):
            return 'toutiao';
        case /aweme/i.test(UA):
            return 'douyin';
        case /live_stream_\d+/i.test(UA):
            return 'huoshan';
        case /VideoArticle/i.test(UA):
            return 'xigua';
        case /Super \d.\d.\d/i.test(UA):
            return 'pipixia';
        case /BDGameSDK/i.test(UA):
            return 'game';
        case /MicroMessenger/i.test(UA):
            return 'wechat';
        case / QQ/i.test(UA):
            return 'qq';
        case /-bcy\/\d.\d.\d/.test(UA):
            return 'banciyuan';
        default:
            return 'unknow';
    }
};
// 生成带有邀请码的URL
export var createTokenUrl = function (url, key, value, splitOprator) {
    var _a;
    if (splitOprator === void 0) { splitOprator = '_'; }
    if (!url || !key || !value) {
        throw new Error('需要输入url(链接),key(邀请码名称), value(邀请码值)参数');
    }
    return mergeParams(url, (_a = {},
        _a[key] = "".concat(splitOprator).concat(value).concat(splitOprator),
        _a));
};
// 获取URL上的邀请码
export var getUrlToken = function (url, key, splitOprator) {
    if (splitOprator === void 0) { splitOprator = '_'; }
    try {
        var expression = new RegExp("(".concat(key, ")=").concat(splitOprator, "[^=&").concat(splitOprator, "]*_"), 'gi');
        var matchs = url.match(expression);
        if (!matchs) {
            return null;
        }
        var matchToken_1 = [];
        matchs.forEach(function (item) {
            var tkVal = item.split('=')[1];
            var tkArr = tkVal.split('');
            tkArr.pop();
            tkArr.shift();
            matchToken_1.push(tkArr.join(''));
        });
        if (matchToken_1[0]) {
            return matchToken_1[0];
        }
        return null;
    }
    catch (e) {
        return null;
    }
};
// 序列号对象成urlencode形式
export var urlencodeObject = function (param, needEncode) {
    if (needEncode === void 0) { needEncode = false; }
    if (getType(param) !== 'Object') {
        console.info('urlencode target is not an Object');
        return '';
    }
    var keyValues = [];
    for (var key in param) {
        keyValues.push("".concat(key, "=").concat(needEncode ? encodeURIComponent(param[key]) : param[key]));
    }
    return keyValues.join('&');
};
// 版本号对比，如果 versionA >= versionB 返回true，否则返回false
export var compareVersion = function (versionA, versionB) {
    var arrA = versionA.split('.').map(function (i) { return Number(i); });
    var arrB = versionB.split('.').map(function (i) { return Number(i); });
    while (arrA.length || arrB.length) {
        var valA = arrA.shift() || -Infinity;
        var valB = arrB.shift() || -Infinity;
        if (valA > valB) {
            return true;
        }
        else if (valA < valB) {
            return false;
        }
    }
    return true;
};
// 版本号对比versionA和versionB,返回-1,0,1分别表示小于,等于,大于
export var compareVersionReturnNumber = function (versionA, versionB) {
    var arrA = versionA.split('.').map(function (i) { return Number(i); });
    var arrB = versionB.split('.').map(function (i) { return Number(i); });
    while (arrA.length || arrB.length) {
        var valA = arrA.shift() || -Infinity;
        var valB = arrB.shift() || -Infinity;
        if (valA > valB) {
            return 1;
        }
        else if (valA < valB) {
            return -1;
        }
    }
    return 0;
};
// 获取特定浏览器内核的transform与animation属性和end方法
// [
// animation,
// animationend,
// transform,
// transitionend
// ]
export var getCssName = function () {
    var animEndEventNames = {
        'webkit': 'webkitAnimationEnd',
        'o': 'oAnimationEnd',
        'ms': 'MSAnimationEnd',
        'animation': 'animationend',
    };
    var transitionEndEventNames = {
        'webkit': 'webkitTransitionEnd',
        'o': 'oTransitionEnd',
        'ms': 'MSTransitionEnd',
        'animation': 'transitionend'
    };
    var transformNames = {
        'webkit': '-webkit-transform',
        'o': '-o-transform',
        'ms': '-ms-transform',
        'animation': 'transform',
    };
    var animationNames = {
        'webkit': '-webkit-animation',
        'o': '-o-animation',
        'ms': '-ms-animation',
        'animation': 'animation',
    };
    var key = prefix().lowercase || 'webkit';
    return [
        animationNames[key],
        animEndEventNames[key],
        transformNames[key],
        transitionEndEventNames[key],
    ];
};
var prefix = function () {
    var styles = getCompStyle(document.documentElement), pre = (Array.prototype.slice
        .call(styles)
        .join('')
        .match(/-(moz|webkit|ms)-/) || ['', 'o'])[1], dom = 'WebKit|Moz|MS|O'.match(new RegExp('(' + pre + ')', 'i'))[1];
    return {
        dom: dom,
        lowercase: pre,
        css: '-' + pre + '-',
        js: pre[0].toUpperCase() + pre.substr(1),
    };
};
var getCompStyle = function (elem, classes) {
    return ((window.getComputedStyle
        ? window.getComputedStyle(elem, classes || null)
        : elem.currentStyle) || null);
};
// 将图片url转成base64
export var imageUrlToBase64 = function (url) {
    return new Promise(function (resolve, reject) {
        if (typeof url !== 'string') {
            reject('url must be string type!');
        }
        // 已经是base64的情况
        if (url.startsWith('data:image')) {
            resolve(url);
        }
        var image = new Image();
        image.crossOrigin = 'Anonymous';
        image.onload = function () {
            var cvs = document.createElement('canvas');
            cvs.width = image.width;
            cvs.height = image.height;
            var ctx = cvs.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height);
            var dataUrl = cvs.toDataURL("image/png");
            resolve(dataUrl);
        };
        image.onerror = function (e) {
            reject({ message: 'load image error', e: e });
        };
        image.src = url;
    });
};
// 保存图片
var isLoadToutiaoJSBridge = false;
export var saveImage = function (url, callback) {
    if (callback === void 0) { callback = function (ags) { }; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof url !== 'string') {
                        throw new Error('url is required!');
                    }
                    if (!isDouyin()) return [3 /*break*/, 3];
                    if (!!isLoadToutiaoJSBridge) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadScript('https://unpkg.byted-static.com/latest/fe/game-sdk/lib/umd/toutiao.js', function () {
                            try {
                                return Boolean(window.ToutiaoJSBridge) && Boolean(window.ToutiaoJSBridge.call);
                            }
                            catch (e) {
                                return false;
                            }
                        })];
                case 1:
                    _a.sent();
                    isLoadToutiaoJSBridge = true;
                    _a.label = 2;
                case 2:
                    window.ToutiaoJSBridge.call('downloadMedia', {
                        suffix: '.png',
                        type: 'image',
                        url: url,
                    }, callback);
                    return [2 /*return*/, false];
                case 3:
                    if (!isInGame()) return [3 /*break*/, 6];
                    if (!!window.JSBridge) return [3 /*break*/, 5];
                    return [4 /*yield*/, loadScript('https://unpkg.byted-static.com/bridge/byted-bridge-jssdk/0.1.3/dist/index.min.js', function () {
                            return !!window.JSBridge;
                        })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    window.JSBridge.call('device.saveImage', { url: url }, callback);
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/];
            }
        });
    });
};
// 获取页面最大的z-index层级，如果页面dom较多，计算有延迟、卡顿的可能。
export var findMaxzIndexOnPage = function () {
    var doms = document.querySelectorAll('body *');
    var max = 0;
    try {
        doms.forEach(function (item) {
            var zindex = window.getComputedStyle(item).zIndex;
            if (zindex !== 'auto') {
                max = Math.max(max, Number(zindex) || 0);
            }
        });
    }
    catch (_) { }
    return max;
};
// 显示蒙层
var showMask = function () {
    var curMask = document.querySelector('#downloadMask');
    if (curMask) {
        curMask.style.display = 'block';
        return false;
    }
    var mask = document.createElement('div');
    mask.id = 'downloadMask';
    mask.style.position = 'fixed';
    mask.style.width = '100vw';
    mask.style.height = '100vh';
    mask.style.background = '#f6f6f6';
    mask.style.left = '0';
    mask.style.top = '0';
    mask.style.display = 'block';
    mask.style.overflow = 'hidden';
    mask.style.zIndex = "".concat(findMaxzIndexOnPage() + 1);
    mask.onclick = function () {
        mask.style.display = 'none';
    };
    var imgTips = document.createElement('img');
    imgTips.style.width = '100%';
    imgTips.src = 'https://p1.dailygn.com/tos-cn-i-8vc7tlzf3c/85ebfee658164bcf94c30dabfc4649b4~tplv-8vc7tlzf3c-raw.png';
    mask.appendChild(imgTips);
    document.body.appendChild(mask);
};
// 下载链接
export var download = function (url) {
    if (typeof url !== 'string' || !url) {
        throw new Error('请传入合法的下载url!');
    }
    // 微信显示蒙层
    if (isWeixin() && isAndroid()) {
        showMask();
        return false;
    }
    // 其他环境直接跳转下载地址
    location.href = url;
};
// schema拉起App
export var lanuchApp = function (schema, delay) {
    if (delay === void 0) { delay = 3000; }
    return new Promise(function (resolve, reject) {
        location.href = schema;
        setTimeout(function () {
            if (document.visibilityState === 'hidden') {
                // 已经跳出页面，判断为拉起成功
                resolve();
            }
            else {
                reject();
            }
        }, delay);
    });
};
//# sourceMappingURL=index.js.map